import React, { useEffect, useState } from "react";
import { SubscriptionType } from "../types/SubscriptionType";
import QRCode from "react-qr-code";
import Card from "./Card";

interface SubscriptionProps {
    subscription: SubscriptionType;
}

async function sha256(message: string) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);

    // hash the message
    const hashBuffer = await crypto.subtle.digest("SHA-256", msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string
    const hashHex = hashArray
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    return hashHex;
}

async function generateHash(
    cardNr: string,
    guid: string,
    iat: number,
    deviceId: string
) {
    const dataToHash = cardNr + guid + iat + deviceId;
    const hash = await sha256(dataToHash);
    const hashLast8 = hash.slice(-8).toUpperCase();
    return hashLast8;
}

const INTERVAL_SECONDS = 5; // in seconds

const Subscription: React.FC<SubscriptionProps> = ({ subscription }) => {
    const [data, setData] = useState<string>("");
    const [timestamp, setTimestamp] = useState<number>(0);
    const [progress, setProgress] = useState<number>(0);

    useEffect(() => {
        const generateData = async () => {
            let data;
            if (subscription.type === "primary") {
                const hash = await generateHash(
                    subscription.card,
                    "2L8",
                    timestamp,
                    subscription.device
                );
                data = `GM2:${subscription.card}:2L8:${timestamp}:${hash}`;
            } else {
                data = subscription.name || "Static QR";
            }

            setData(data);
        };

        generateData();
    }, [timestamp, subscription]);

    useEffect(() => {
        setTimestamp(Math.floor(Date.now() / 1000));
        const interval = setInterval(() => {
            setTimestamp(Math.floor(Date.now() / 1000));
        }, INTERVAL_SECONDS * 1000);
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        let animationFrame: number;
        let start = performance.now();
        function animate(now: number) {
            const elapsed = (now - start) / 1000;
            let percent = (elapsed / INTERVAL_SECONDS) * 100;
            if (percent > 100) percent = 100;
            setProgress(percent);
            if (percent < 100) {
                animationFrame = requestAnimationFrame(animate);
            } else {
                start = performance.now();
                setProgress(0);
                animationFrame = requestAnimationFrame(animate);
            }
        }
        animationFrame = requestAnimationFrame(animate);
        return () => cancelAnimationFrame(animationFrame);
    }, [timestamp]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
            }}
        >
            <Card
                style={{
                    backgroundColor: "white",
                    borderRadius: "10px",
                    padding: "10px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <QRCode
                    level="L" // low
                    style={{
                        padding: "10px",
                        backgroundColor: "white",
                    }}
                    value={data}
                />
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        marginTop: "5px",
                        padding: "2px",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "white",
                        fontSize: "12px",
                        fontWeight: "bold",
                        width: "70%",
                        backgroundColor: "rgb(254, 112, 0)",
                        marginBottom: "-6px",
                    }}
                >
                    CardNumber {subscription.card}
                </div>
            </Card>
            <div>
                {subscription.type === "primary" && (
                    <progress
                        style={{
                            width: "calc(300px )",
                            height: "4px",
                            backgroundColor: "white",
                            border: "none",
                            appearance: "none",
                            overflow: "hidden",
                            // WebkitAppearance: "none",
                            // WebkitBorderRadius: "5px",
                            // WebkitBackgroundClip: "padding-box",
                        }}
                        value={progress}
                        max={100}
                        className="orange-progress"
                    />
                )}
                <h3>TON QR CODE</h3>
                <p
                    style={{
                        fontSize: "16px",
                        textAlign: "center",
                        padding: "15px",
                    }}
                >
                    Scanne ce QR code pour entrer dans le club ou pour profiter
                    des options (si souscrites). Présente ton QR code à environ
                    20 cm du scanner
                </p>
            </div>
        </div>
    );
};

export default Subscription;
